import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import StudentInfo from '../../../../components/StudentInfo'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'

//import GetAllFormFields from '../../../../components/_utils/formUtils'
import styles from './styles.less'
import moment from 'moment'

import { Button, Card, Col, Form, Icon, notification, Radio, Row, Select, Tabs } from 'antd'
import _ from 'lodash'


import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { LAPI_URL } from '../../../../request'
import { connect } from 'react-redux'
import StudentHeader from '../../../../components/studentHeader'
import { getUrlPushWrapper } from '../../../../routes'
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const TabPane = Tabs.TabPane
const RadioGroup = Radio.Group
const Option = Select.Option
const modeObj = {
    'Consultancy Charges': 'Fee',
    'Pay After Visa': 'afterVisa',
    'Original Document Submission': 'Document',
    'Reference': 'Reference'
    // 'By Associate Partner': 'Partner'
}

@Form.create()
class AddRegistrationFees extends PureComponent {


    handleSubmit = e => {
        const { dispatch, form } = this.props

        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let obj = {}
                if (this.state.registrationType == 'Consultancy Charges') {
                    obj = {
                        _id: this.state.inquiryId,
                        registrationDesk: {
                            ...values,
                            completed: true,
                            mode: this.state.mode
                        },
                        paymentFollowUp: {
                            followUpDate: values.followUpDate,
                            studentId: this.state.inquiryId,
                            detail: values.detail,
                            followUpType: values.followUpType
                        }
                    }
                } else if (this.state.registrationType == 'Pay After Visa') {
                    obj = {
                        _id: this.state.inquiryId,
                        registrationDesk: {
                            ...values,
                            completed: false,
                            mode: this.state.mode
                        }
                    }
                } else {
                    obj = {
                        _id: this.state.inquiryId,
                        registrationDesk: {
                            ...values,
                            mode: this.state.mode,
                            completed: true,
                            total: this.state.tutionFee,
                            balance: this.state.tutionFee,
                            paid: 0
                        },
                        paymentFollowUp: {
                            followUpDate: values.followUpDate,
                            studentId: this.state.inquiryId,
                            detail: values.detail,
                            followUpType: values.followUpType
                        }
                    }
                }

                if (this.state.registrationType == 'Reference') {
                    let newObj = {
                        _id: this.state.inquiryId,
                        referenceCode: values.referenceCode
                    }
                    this.checkReferenceCode(newObj, (resp1) => {
                        if (resp1.success) {
                            this.addRegistration(obj)
                        } else {
                            notification.error({
                                message: 'Error Reference',
                                description: resp1.msg ? resp1.msg : 'Try again'
                            })
                        }
                    })
                } else {
                    this.addRegistration(obj)
                }
            }
        })
    }
    setFormValues = async inquiryId => {
        const { dispatch, form } = this.props
        try {

            this.setState({ screenLoad: true })
            let { doc } = await Request.getInquiry(inquiryId)

            if (doc) {
                this.setState({ admissionUserId: doc.admissionUserId })
                if (doc.location && doc.location.location === "Loyality Program" && doc.membershipDetail) {

                }
                let loadPartner = async () => {
                    let { data: channelPartnerList } = await Request.getSimplePartners({
                        results: 10000
                    })
                    this.setState({ channelPartnerList })

                }

                let { registrationDesk, counsellingDesk, atLevel, registrationsDesk } = doc

                if (registrationsDesk) {
                    this.setState({ allRegistrationPayments: registrationsDesk })
                }

                if (registrationDesk) {
                    if (registrationDesk.completed) {
                        this.setState({
                            savedRegistration: registrationDesk,
                            allRegistrationPayments: [registrationDesk],
                            showForm: true,
                            currentDesk: atLevel,
                            moveToNextDesk: atLevel && atLevel == 'Registration Desk' ? true : false
                        })
                    } else {
                        this.setState({ showForm: true }, () => loadPartner())
                    }


                } else {
                    this.setState({ showForm: true }, () => loadPartner())
                }
                this.setState({ screenLoad: false, info: doc })

            } else {
                this.setState({ screenLoad: false, info: null })
            }


        } catch (e) {
            console.log(e)
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            balance: 0,
            registrationType: null,
            screenLoad: false,
            moveToNextDesk: false,
            channelPartnerList: [],
            channelPartnerName: null,
            mode: null,
            showForm: true,
            showSaveBtn: false,
            showAgreementForm: false,
            inquiryId: null,
            info: null,
            savedRegistration: null,
            aggreementSigned: 'No',
            sendEmailStatus: 'Yes',
            sendSMSStatus: 'Yes',
            allUsers: [],
            admissionUserId: [],
            localUser: {},
            totalPaidAMNT: 0,
            totalCountryPaymentDone: 0,
            allRegistrationPayments: [],
            registrationOption: [
                'Original Document Submission']
        }
    }

    async sendReferenceCode() {
        this.props.dispatch(showLoader())
        let resp = await Request.sendReferenceCode(this.state.inquiryId)
        if (resp.success) {
            this.props.dispatch(hideLoader())
            notification.success({
                message: 'Success',
                description: resp.msg
            })
        } else {
            this.props.dispatch(hideLoader())
            notification.error({
                message: 'Reference code sending error',
                description: resp.msg
            })
        }

    }

    async resendReferenceCode() {
        this.props.dispatch(showLoader())
        let resp = await Request.resendReferenceCode(this.state.inquiryId)
        if (resp.success) {
            this.props.dispatch(hideLoader())
            notification.success({
                message: 'Success',
                description: resp.msg
            })
        } else {
            this.props.dispatch(hideLoader())
            notification.error({
                message: 'Reference code sending error',
                description: resp.msg
            })
        }

    }

    async checkReferenceCode(obj, callback) {
        let resp = await Request.checkReferenceCode(obj)
        return callback(resp)
    }

    async loadRegistrationOptions() {
        let { localUser, registrationOption } = this.state
        let companyDetails = await Request.getCompanySetting({ businessId: localUser.businessId })
        if (companyDetails && companyDetails.studentPaymentOptions && companyDetails.paymentOptions.length) {
            let finalRegistrationOptions = [...companyDetails.paymentOptions, ...registrationOption]
            this.setState({ registrationOption: finalRegistrationOptions })
        }
    }

    async componentDidMount() {
        let searchParams = await new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        if (inquiryId) {
            this.setState({ inquiryId: inquiryId })
            this.setFormValues(inquiryId)
        }
        this.loadAllCountries();
        let localUser = JSON.parse(localStorage.getItem("user"));

        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isAdmission: true,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
            userId: localUser._id,
        });
        this.setState({ allUsers, localUser });
        this.loadRegistrationOptions()
    }

    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        }
        Request.getCountriesWithoutAuth(params)
            .then(resp => {
                if (resp) {
                    this.setState({ countries: resp.data })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    async addRegistration(obj) {
        this.props.dispatch(showLoader());
        let { success, doc, msg } = await Request.addRegistration({ ...obj })

        this.props.dispatch(hideLoader())
        if (success) {
            notification.success({
                message: 'Success',
                description: 'Registration Done Successfully'
            })
            const { registrationDesk, registrationsDesk } = doc

            if (registrationDesk) {
                if (registrationDesk.completed && doc.atLevel == 'Registration Desk') {
                    this.setState({ moveToNextDesk: true, currentDesk: doc.atLevel })
                }
                if (registrationDesk.mode === "afterVisa" && doc.atLevel == "Registration Desk") {
                    this.setState({ moveToNextDesk: true, currentDesk: doc.atLevel })
                }

            }
            this.setState({ savedRegistration: registrationDesk, showForm: false, showAgreementForm: true, allRegistrationPayments: registrationsDesk })
            this.props.form.resetFields()


        } else {
            notification.error({
                message: 'Error Saving',
                description: msg ? msg : 'Try again'
            })
        }
    }

    async getCountryPreviousPayments(countryId) {
        let totalPaid = 0;
        let data = await Request.getInquiry(this.state.inquiryId)
        // if(data.doc && data.doc.registrationDesk && data.doc.registrationDesk.paid) {
        //     totalPaid += data.doc.registrationDesk.paid
        // }
        let previousPayments = data.doc.registrationsDesk && data.doc.registrationsDesk.find(obj => obj.countryId === countryId)
        if (previousPayments && previousPayments.payments.length > 0) {
            _.each(previousPayments.payments, (item) => {
                totalPaid += item.paid
            })
        }
        return totalPaid
    }


    moveToApplicationDesk() {
        if (this.state.admissionUserId.length == 0) {
            return notification.error({
                message: 'Please select Admission User to move the student to Application Desk.'
            })
        }
        this.props.dispatch(showLoader())
        let obj = {
            _id: this.state.inquiryId,
            aggreementSigned: this.state.aggreementSigned == 'Yes' ? true : false,
            sendEmailStatus: this.state.sendEmailStatus,
            sendSMSStatus: this.state.sendSMSStatus,
            admissionUserId: this.state.admissionUserId
        }
        Request.movedToApplicationDesk(obj).then(({ data, error, message }) => {
            if (!error) {
                this.setState({ moveToNextDesk: false })
                notification.success({
                    message: message
                })
                this.props.dispatch(getUrlPushWrapper('desk.registration'))
            } else {
                notification.error({
                    message: message
                })
            }
            this.props.dispatch(hideLoader())
        })
    }

    setTutionFee = () => {
        this.props.form.setFieldsValue({
            total: this.state.tutionFee,
            balance: this.state.tutionFee - this.state.totalCountryPaymentDone,
            amountPaid: this.state.totalCountryPaymentDone,
            dateOfReciept: moment()
        })

    }

    getFilterCountries = () => {
        if (this.state.countries && this.state.info && this.state.info.counsellingDesk) {
            return this.state.countries.filter(
                country => this.state.info.counsellingDesk.course.find(
                    course => course.countryId === country._id))

        }
        return []
    }

    render() {
        const { submitting, dispatch, form } = this.props
        const {
            balance,
            savedRegistration,
            showForm,
            info,
            showSaveBtn, tutionFee,
            showAgreementForm,
            registrationType,
            registrationOption,
            channelPartnerName, screenLoad, moveToNextDesk, currentDesk, allRegistrationPayments
        } = this.state


        const {
            form: { getFieldDecorator }
        } = this.props

        // const registrationOption = [
        //     'Consultancy Charges',
        //     'Pay After Visa',
        //     'Cash Payment',
        //     'Original Document Submission',
        //     'Reference'
        //     // 'By Associate Partner'
        // ]
        // let companyDetails = await Request.getCompanySetting({businessId:this.state.localUser.businessId})
        // if(companyDetails.studentPaymentOptions && companyDetails.paymentOptions.length) {
        //     registrationOption = [...companyDetails.paymentOptions, ...registrationOption]
        // }

        const FeesForm = {
            fields: [
                {
                    label: 'Country',
                    key: 'country',
                    type: 'select',
                    required: true,
                    options: this.getFilterCountries(),
                    placeholder: 'Select Country',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.countryName,
                    onChange: (async (v) => {
                        this.props.form.setFieldsValue({
                            country: v
                        })
                        const matchedCountry = this.state.countries.find(country => country._id === v)
                        let paymentDone = await this.getCountryPreviousPayments(v)
                        this.setState({ tutionFee: matchedCountry.totalConsultancyFee ? matchedCountry.totalConsultancyFee : 20000, totalCountryPaymentDone: paymentDone ? paymentDone : 0 }, () => {
                            this.setTutionFee()
                        })
                    })
                },
                {
                    label: 'Total Fees',
                    key: 'total',
                    type: 'number',
                    defaultValue: 20000,
                    disabled: true
                },
                {
                    label: 'Redeem Credits',
                    key: 'redeemedCredits',
                    type: 'number',
                    defaultValue: 0,
                    hidden: info && info.location && info.location === 'Loyality Program' ? false : true,
                    onChange: v => {
                        let total = form.getFieldValue('total')
                        let balance = total - v
                        this.setState({ balance: balance })
                        this.props.form.setFieldsValue({
                            // balance: balance,
                            redeemedCredits: v
                        })
                    }
                },
                {
                    label: 'Previous Payment',
                    key: 'amountPaid',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Received Amount',
                    key: 'paid',
                    required: true,
                    type: 'number',
                    max: tutionFee ? parseInt(tutionFee) : 0,
                    min: 0,
                    onChange: v => {
                        let total = form.getFieldValue('total')
                        let amountPaid = form.getFieldValue('amountPaid')
                        let memberCredit = form.getFieldValue('redeemedCredits')
                        let balance
                        if (memberCredit) {
                            balance = total - memberCredit - amountPaid - v;
                        } else {
                            balance = total - amountPaid - v;
                        }
                        this.setState({ totalPaidAMNT: v, balance: balance });
                        this.props.form.setFieldsValue({
                            balance: balance,
                            paid: v
                        })
                    }
                },
                {
                    label: 'Balance',
                    key: 'balance',
                    type: 'number',
                    disabled: true,
                    required: true
                },
                {
                    label: 'Document',
                    key: 'documentName',
                    type: 'textArea',
                    rows: 10,
                    hidden: (this.state.totalPaidAMNT == 0 ? false : true),
                    required: (this.state.totalPaidAMNT == 0 ? true : false),
                },
                {
                    label: 'Receipt No',
                    key: 'receipt',
                },
                {
                    label: 'Date of Receipt',
                    key: 'dateOfReciept',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Agreement',
                    key: 'studentAgreement',
                    type: 'file',
                    required:
                        this.state &&
                            this.state.info &&
                            this.state.info.associativePartnerId
                            ? false
                            : true
                }
            ]
        }

        const documentForm = {
            fields: [
                {
                    label: 'Document',
                    key: 'documentName',
                    type: 'textArea',
                    rows: 10,
                    required: true
                }
            ]
        }
        const referenceForm = {
            fields: [
                {
                    label: 'Reference Code',
                    key: 'referenceCode',
                    required: true
                },
                {
                    label: 'Details',
                    key: 'details',
                    type: 'textArea',
                    row: 10,
                    required: true
                }
            ]
        }
        const followInputTypes = {
            tabTitle: 'Add Follow Up',
            fields: [
                {
                    label: 'Next Payment Date',
                    key: 'followUpDate',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Details',
                    key: 'detail',
                    type: 'textArea',
                    rows: 10,
                    required: true
                },
                {
                    label: 'FollowUp Out Come',
                    key: 'followUpType',
                    type: 'select',
                    required: true,
                    options: ['Payment Completed', 'Payment Due', 'Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town'],
                    placeholder: 'Select followUp Type',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            followUpType: v
                        })
                    }
                }
            ]
        };

        let payAfterVisaTypes = {
            fields: [
                {
                    label: 'Country',
                    key: 'country',
                    type: 'select',
                    required: true,
                    options: this.getFilterCountries(),
                    placeholder: 'Select Country',
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.countryName,
                    onChange: (async (v) => {
                        this.props.form.setFieldsValue({
                            country: v
                        })
                    })
                },
                {
                    label: 'Total Payment',
                    key: 'total',
                    type: 'number',
                    onChange: v => {
                        this.props.form.setFieldsValue({ balance: v, total: v })
                    }
                },
                {
                    label: 'Received Amount',
                    key: 'paid',
                    type: 'number',
                    min: 0,
                    onChange: v => {
                        let total = form.getFieldValue('total')
                        let balance = total - v;
                        this.setState({ totalPaidAMNT: v, balance: balance });
                        this.props.form.setFieldsValue({
                            balance: balance,
                            paid: v
                        })
                    }
                },
                {
                    label: 'Balance',
                    key: 'balance',
                    type: 'number',
                    disabled: true,
                    required: true
                },
            ]
        }

        const submitFormLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 10, offset: 7 },
                md: { span: 12, offset: 8 }
            }
        }
        let allRegistrationPaymentsHtml = [];
        allRegistrationPayments.map((registrationPayment) => {
            (registrationPayment.mode === "Fee" || registrationPayment.mode === "afterVisa") && registrationPayment.payments && registrationPayment.payments.map((payment, index) => {
                allRegistrationPaymentsHtml.push(<div>
                    <Card style={{ marginTop: 10 }} title={`${registrationPayment.countryName} - ${moment(payment.dateOfReciept).format('DD-MMM-YYYY')}`}>
                        <div><label>Mode: Cash</label></div>
                        <div><label>Total: {payment.total}</label></div>
                        <div><label>Paid: {payment.paid}</label></div>
                        <div><label>Total Paid: {payment.totalPaid}</label></div>
                        {
                            payment.paid == 0 ?
                                <div><label>Document: {payment.documentName}</label></div>
                                : null
                        }
                        <div><label>Balance: {payment.balance}</label></div>
                        <div><label>Receipt No: {payment.receipt}</label></div>
                        <div><label>Receipt
                            On: {moment(payment.dateOfReciept).format('DD-MMM-YYYY')}</label>
                        </div>
                    </Card>
                </div>)
            })
        })

        const feesModule = (
            <div
                className={[styles.marginTop10]}
                title={this.state.registrationType}>
                <GetAllFormFields
                    apiurl={LAPI_URL}
                    inputSchema={FeesForm}
                    getFieldDecorator={getFieldDecorator}
                />
                {
                    balance ?
                        <div>
                            <GetAllFormFields
                                inputSchema={followInputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        : null
                }
            </div>
        )
        const payAfterVisaModule = (
            <div
                className={[styles.marginTop10]}
                title={this.state.registrationType}
            >
                <GetAllFormFields
                    inputSchema={payAfterVisaTypes}
                    getFieldDecorator={getFieldDecorator}
                />
            </div>
        )
        const documentModule = (
            <div
                className={[styles.marginTop10]}
                title={this.state.registrationType}>
                <GetAllFormFields
                    inputSchema={documentForm}
                    getFieldDecorator={getFieldDecorator}
                />
            </div>
        )

        const referenceModule = (
            <div
                className={[styles.marginTop10]}
                title={this.state.registrationType}>
                <div>
                    <a className={[styles.resendOtp]} onClick={() => this.resendReferenceCode()}>Resend</a>
                    <GetAllFormFields
                        inputSchema={referenceForm}
                        getFieldDecorator={getFieldDecorator}
                    />
                </div>
            </div>
        )

        const deskUserForm = {
            fields: [
                {
                    label: "Application Desk User",
                    key: "admissionUserId",
                    type: "select",
                    mode: 'multiple',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    keyAccessor: (x) => x._id,
                    valueAccessor: (x) => x.name,
                    options: this.state.allUsers ? this.state.allUsers : {},
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ admissionUserId: v });
                    },
                }
            ]
        }

        return (
            <PageHeaderWrapper
                title={info && info.studentName ? `Registration of ${info.studentName}` : 'Registration Screen'}>

                {
                    info && info._id ?

                        <div>
                            <div style={{ marginBottom: 10 }}>
                                <StudentHeader
                                    info={this.state.inquiryId}
                                    rollBackLevel={'Front Desk'}
                                    done={() => {
                                        dispatch(getUrlPushWrapper('desk.registration'))
                                    }}
                                    data={info}
                                    dispatch={this.props.dispatch}
                                />
                            </div>
                        </div> : null}

                {
                    info ? <Card bordered={true} style={{ marginBottom: 10 }}>
                        <StudentInfo
                            info={info}

                        />
                    </Card> : null
                }

                {
                    info && info.atLevel == 'Front Desk' ? <div style={{ color: 'red' }}>Registration Not Allowed</div> :
                        <Card bordered={false} loading={screenLoad}>
                            <div style={{ display: showForm ? 'block' : 'none' }}>
                                <Form onSubmit={this.handleSubmit} >
                                    <div bordered={true}>
                                        <Form.Item>
                                            <Row>
                                                <Col span={8} className={styles.radioLabel}>
                                                    Registration Options :{' '}
                                                </Col>
                                                <Col span={16}>
                                                    <RadioGroup
                                                        options={registrationOption}
                                                        required
                                                        onChange={v => {
                                                            this.setState({
                                                                registrationType: v.target.value,
                                                                mode: modeObj[v.target.value],
                                                                showSaveBtn: true

                                                            })
                                                            this.props.form.setFieldsValue({
                                                                registrationType: v.target.value
                                                            })

                                                            if (v.target.value == 'Consultancy Charges') {
                                                                setTimeout(() => {
                                                                    this.setTutionFee()
                                                                }, 100)
                                                            }
                                                            if (v.target.value == 'Reference') {
                                                                setTimeout(() => {
                                                                    this.sendReferenceCode()
                                                                    this.setTutionFee()
                                                                }, 100)
                                                            }
                                                        }}
                                                        value={this.state.registrationType}
                                                    />
                                                </Col>
                                            </Row>
                                        </Form.Item>

                                        {registrationType == 'Consultancy Charges'
                                            ? feesModule
                                            : null}
                                        {registrationType == 'Pay After Visa'
                                            ? payAfterVisaModule
                                            : null}

                                        {registrationType == 'Original Document Submission'
                                            ? documentModule
                                            : null}

                                        {registrationType == 'Reference'
                                            ? referenceModule
                                            : null}
                                        {showSaveBtn ? (
                                            <Form.Item>
                                                <div className={styles.buttonDiv1} style={{ marginTop: 10 }}>
                                                    <Row>
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            loading={this.props.loading}>
                                                            SAVE
                                                        </Button>
                                                    </Row>
                                                </div>
                                            </Form.Item>
                                        ) : null}
                                    </div>
                                </Form>
                            </div>
                            <div>
                                <div
                                    className={[styles.marginTop10]}
                                    title={
                                        <span>
                                            <Icon style={{ color: 'green' }} type={'check'} /> REGISTRATION
                                            DONE
                                        </span>
                                    }>


                                    <h3>REGISTRATION DETAILS ARE</h3>

                                    {

                                        allRegistrationPaymentsHtml.length ? allRegistrationPaymentsHtml :

                                            savedRegistration && savedRegistration.mode == 'Fee' ?
                                                <div>
                                                    <div><label>Mode: Cash</label></div>
                                                    <div><label>Total: {savedRegistration.total}</label></div>
                                                    <div><label>Paid: {savedRegistration.paid}</label></div>
                                                    {
                                                        savedRegistration.paid == 0 ?
                                                            <div><label>Document: {savedRegistration.documentName}</label></div>
                                                            : null
                                                    }
                                                    <div><label>Balance: {savedRegistration.balance}</label></div>
                                                    <div><label>Receipt No: {savedRegistration.receipt}</label></div>
                                                    <div><label>Receipt
                                                        On: {moment(savedRegistration.dateOfReciept).format('DD-MMM-YYYY')}</label>
                                                    </div>
                                                </div>
                                                : null
                                    }
                                    {
                                        savedRegistration && savedRegistration.mode == 'Document' ?
                                            <div>
                                                <div><label>Mode: Document</label></div>
                                                <div><label>Document: {savedRegistration.documentName}</label></div>
                                            </div>
                                            : null
                                    }
                                    {
                                        savedRegistration && savedRegistration.mode == 'Reference' ?
                                            <div>
                                                <div><label>Mode: Reference</label></div>
                                                <div><label>Details: {savedRegistration.details}</label></div>

                                            </div>
                                            : null
                                    }
                                </div>
                            </div>

                            {savedRegistration && currentDesk == 'Registration Desk' && savedRegistration && savedRegistration.mode ?
                                <div>

                                    <div className={styles.buttonDiv2}>
                                        {moveToNextDesk ? (
                                            <Row>
                                                <Col span={8}>
                                                    <span>Agreement Signed: </span>
                                                    <Select
                                                        allowClear
                                                        showSearch={true}
                                                        style={{ width: 200 }}
                                                        placeholder="Select Agreement"
                                                        defaultValue={this.state.aggreementSigned}
                                                        onChange={(v) => {

                                                            this.setState({
                                                                aggreementSigned: v

                                                            })
                                                            this.props.form.setFieldsValue({
                                                                aggreementSigned: v
                                                            })

                                                        }}
                                                        filterOption={(input, option) => {
                                                            return (
                                                                option.props.children
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            )
                                                        }}>
                                                        <Option value="Yes">Yes</Option>
                                                        {/* <Option value="No">No</Option> */}

                                                    </Select>
                                                </Col>
                                                <Col span={8} >
                                                    {/* <span>Application Desk User: </span>
                                                    <Select
                                                        style={{ width: '200px' }}
                                                        showSearch={true}
                                                        mode="multiple"
                                                        value={
                                                            this.state.admissionUserId ? this.state.admissionUserId : []
                                                        }
                                                        onChange={item => {
                                                            this.setState({ admissionUserId: item })
                                                        }}>
                                                        {
                                                            this.state.allUsers.map(item => (
                                                                <Option key={item._id} value={item._id}>
                                                                    {item.name}
                                                                </Option>
                                                            ))
                                                        }
                                                    </Select> */}
                                                </Col>
                                                <Col span={4} style={{ marginTop: '13px' }} >
                                                    <Button
                                                        type="primary"
                                                        onClick={() => {
                                                            this.moveToApplicationDesk()
                                                        }}
                                                        loading={this.props.loading}>
                                                        Process to Application Desk
                                                        <Icon type="right" />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ) : null}
                                    </div>
                                </div>
                                : null
                            }
                        </Card>
                }
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddRegistrationFees)
